var i=i=>({visibility:i?"visible":"hidden",position:i?"relative":"absolute",pointerEvents:i?"auto":"none",height:i?"auto":0,overflow:"hidden"});export{i as getVisibilityStyle};
//# sourceMappingURL=getVisibilityStyle.js.map